import { string } from "prop-types";

import styled from "styled-components";

import { INACTIVE_HEIGHT } from "CrossFeatureComponents/MemberToolbar/styleConstants";

import CloseButton from "../../shared/CloseButton";

const ActiveState = ({ color }) => <SCloseButton color={color} text="Close" />;

const SCloseButton = styled(CloseButton)`
  transform: translateY(1px);
  min-height: ${INACTIVE_HEIGHT}px;
`;

ActiveState.propTypes = { color: string };

export default ActiveState;
